import { useGateValue } from '@statsig/react-bindings';

export default function useIsNomadEnabled() {
  return useGateValue('nomad_rollout');
}
